import * as React from 'react';
import {
  Box,
  Typography,
} from '@mui/material'

import Toolbar from '../components/Toolbar'


export default function Forecast() {
  return(
    <Box className="w-full h-full ">
      <Toolbar/>
      <Typography>Forecast</Typography>
    </Box>
  );
}